// extracted by mini-css-extract-plugin
export default {"cus_radio":"DRadioInputs_cus_radio__Vevjx"};